import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { Inbox } from "lucide-react";
import { RequestCard, TripCard } from "../components/cards";
import { Spinner, EmptyState } from "../components/common";
import { Tabs, TabsList, TabsTrigger, TabsContent } from "../components/ui/tabs";
import api from "../lib/api";
import { useI18n } from "../lib/i18n";
import { useAuth } from "../context/AuthContext";

export default function MyRequests() {
  const { t } = useI18n();
  const { user } = useAuth();
  const navigate = useNavigate();
  const [reqs, setReqs] = useState([]);
  const [loading, setLoading] = useState(true);
  const isBawainer = user?.role === "bawainer";

  useEffect(() => {
    setLoading(true);
    api.get(isBawainer ? "/requests/incoming" : "/requests/mine")
      .then((r) => setReqs(r.data)).finally(() => setLoading(false));
  }, [isBawainer]);

  const goChat = (r) => r.conversation_id && navigate(`/chat/${r.conversation_id}`);

  if (loading) return <Spinner />;

  return (
    <div className="space-y-5">
      <h1 className="font-heading font-extrabold text-2xl text-navy">{isBawainer ? "Incoming Requests" : "My Requests"}</h1>
      {reqs.length === 0 ? (
        <EmptyState icon={Inbox} title="Belum ada request"
          subtitle={isBawainer ? "Request dari TITIPER akan muncul di sini." : "Kirim request ke BAWAINER untuk memulai."}
          action={<button onClick={() => navigate(isBawainer ? "/explore" : "/whos-going")} data-testid="req-empty-cta" className="rounded-full bg-lime text-navy font-bold px-5 py-2.5 text-sm">{isBawainer ? t("nav_explore") : t("find_bawainer")}</button>} />
      ) : (
        <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-4">
          {reqs.map((r) => (
            <RequestCard key={r.id} req={r}
              action={r.conversation_id && (
                <button onClick={() => goChat(r)} data-testid={`req-open-chat-${r.id}`}
                  className="mt-3 w-full rounded-full bg-navy text-white font-bold py-2.5 text-sm hover:bg-navy-700 transition-colors">
                  Buka Chat
                </button>
              )} />
          ))}
        </div>
      )}
    </div>
  );
}
